import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../axios/instance';

export const fetchFiles = createAsyncThunk('fileStore/fetchFiles', async (params = {}) => {
  const { search, type, contact, userId, businessId } = params || {};
  const res = await API.get('fileStore/fileStore', {
    params: {
      ...(search ? { search } : {}),
      ...(type && type !== 'all' ? { type } : {}),
      ...(contact ? { contact } : {}),
      ...(userId ? { userId } : {}),
      ...(businessId ? { businessId } : {}),
    },
  });
  return res.data;
});

export const uploadFile = createAsyncThunk('fileStore/uploadFile', async (payload) => {
  // payload: { userId, businessId, fileName, fileType, fileSize, dataBase64, contactIds }
  // Increase timeout for potentially large uploads
  const size = Number(payload?.fileSize) || 0;
  // Base 5 min; add 1 min per ~10MB, cap at 15 min
  const dynamicTimeout = Math.min(15 * 60_000, Math.max(5 * 60_000, 5 * 60_000 + Math.ceil(size / (10 * 1024 * 1024)) * 60_000));
  const res = await API.post('fileStore/fileStore', payload, {
    timeout: dynamicTimeout,
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
  });
  return res.data?.result || res.data;
});

export const deleteFile = createAsyncThunk('fileStore/deleteFile', async (id) => {
  await API.delete(`fileStore/fileStore/${id}`);
  return id;
});

export const getFileById = createAsyncThunk('fileStore/getFileById', async (id) => {
  const res = await API.get(`fileStore/fileStore/${id}`);
  return res.data;
});

export const updateFile = createAsyncThunk('fileStore/updateFile', async ({ id, data }) => {
  const res = await API.put(`fileStore/fileStore/${id}`, data);
  return res.data?.result || res.data;
});
